import React from "react";

export default function StandartFrame1({ fill, frameTextToggle, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 316 316"
    >
      <g transform={frameTextToggle}>
        <path
          fill={fill}
          fillRule="evenodd"
          d="M286 8H30C17.85 8 8 17.85 8 30v256c0 12.15 9.85 22 22 22h256c12.15 0 22-9.85 22-22V30c0-12.15-9.85-22-22-22ZM30 0C13.431 0 0 13.431 0 30v256c0 16.569 13.431 30 30 30h256c16.569 0 30-13.431 30-30V30c0-16.569-13.431-30-30-30H30Z"
          clipRule="evenodd"
        />
        {children}
      </g>
    </svg>
  );
}
